import { create } from 'zustand';

interface UIState {
  isSidebarOpen: boolean;
  isSidebarCollapsed: boolean;
  theme: 'light' | 'dark';
  toggleSidebar: () => void;
  closeSidebar: () => void;
  openSidebar: () => void;
  toggleSidebarCollapse: () => void;
  setSidebarCollapse: (collapsed: boolean) => void;
  setTheme: (theme: 'light' | 'dark') => void;
}

const getInitialCollapse = (): boolean => {
  const stored = localStorage.getItem('charikaty-sidebar-collapsed');
  if (stored !== null) {
    return stored === 'true';
  }
  // Default to collapsed for tablet width (< 1024px)
  return window.innerWidth < 1024;
};

export const useUIStore = create<UIState>((set) => ({
  isSidebarOpen: false,
  isSidebarCollapsed: getInitialCollapse(),
  theme: (localStorage.getItem('charikaty-theme') as 'light' | 'dark') || 'dark',
  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  closeSidebar: () => set({ isSidebarOpen: false }),
  openSidebar: () => set({ isSidebarOpen: true }),
  toggleSidebarCollapse: () => set((state) => {
    const newVal = !state.isSidebarCollapsed;
    localStorage.setItem('charikaty-sidebar-collapsed', String(newVal));
    return { isSidebarCollapsed: newVal };
  }),
  setSidebarCollapse: (collapsed) => {
    localStorage.setItem('charikaty-sidebar-collapsed', String(collapsed));
    set({ isSidebarCollapsed: collapsed });
  },
  setTheme: (theme) => {
    localStorage.setItem('charikaty-theme', theme);
    document.documentElement.classList.toggle('dark', theme === 'dark');
    set({ theme });
  },
}));
